module.exports = __webpack_public_path__ + "img/RectangleFrame.2fb874ae.png";